import { PageHero } from "@/components/PageHero";
import { SITE } from "@/lib/site-config";
import type { LocaleFaqCopy } from "@/data/faq/locale-copy";

export function LocaleFaqPage({ copy }: { copy: LocaleFaqCopy }) {
  return (
    <>
      <PageHero
        eyebrow={copy.eyebrow}
        title={
          <>
            {copy.h1} <span className="text-[var(--gold)]">{copy.h1Accent}</span>
          </>
        }
        subtitle={copy.subtitle}
        primaryCta={{ label: copy.ctaPrimary, href: SITE.contact.lineUrl }}
        secondaryCta={{ label: `${copy.ctaSecondary} ${SITE.contact.phone}`, href: `tel:${SITE.contact.phone}` }}
        badges={copy.badges}
      />

      <section className="mx-auto max-w-3xl px-4 py-12">
        <p className="speakable-summary rounded-xl border border-[var(--gold)]/40 bg-card p-6 text-sm leading-relaxed text-muted-foreground">
          {copy.answerSummary}
        </p>
      </section>

      <section className="mx-auto max-w-3xl px-4 pb-16">
        <dl className="speakable-faq space-y-4">
          {copy.faq.map((f, i) => (
            <details
              key={f.q}
              open={i < 3}
              className="group rounded-xl border border-border bg-card p-6 open:border-[var(--gold)] open:shadow-[var(--shadow-elegant)]"
            >
              <summary className="flex cursor-pointer list-none items-start justify-between gap-4">
                <dt className="text-base font-semibold text-foreground group-open:text-[var(--primary)]">
                  {i + 1}. {f.q}
                </dt>
                <span className="mt-1 text-[var(--gold)] transition-transform group-open:rotate-45">+</span>
              </summary>
              <dd className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.a}</dd>
            </details>
          ))}
        </dl>

        <div className="mt-10 rounded-xl border border-border bg-muted/40 p-6">
          <h2 className="text-lg font-semibold text-foreground">{copy.closingTitle}</h2>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{copy.closingBody}</p>
        </div>
      </section>
    </>
  );
}
